export class Role{
  id: number;
  roleName: string;
  roleDescription: string;
}
